export enum AccountSettingsField {
  CHANGE_PASSWORD = "changePassword",
  DELETE_ACCOUNT = "deleteAccount",
  CHANGE_EMAIL = "changeEmail",
}
